import { render, staticRenderFns } from "./exportDynamicTable.vue?vue&type=template&id=06568f62&scoped=true"
import script from "./exportDynamicTable.vue?vue&type=script&lang=js"
export * from "./exportDynamicTable.vue?vue&type=script&lang=js"
import style0 from "./exportDynamicTable.vue?vue&type=style&index=0&id=06568f62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06568f62",
  null
  
)

export default component.exports